export default __webpack_public_path__ + "images/48c7e0d7bab130126610d1afe8df2af0-emoji-healthy.svg";